export const S3_ORIGIN = 'https://s3.agrollama.com';

const COMMON_ASSETS = `${S3_ORIGIN}/common`;
const SEARCH_LOGO = `${COMMON_ASSETS}/agrollama_logo_green_background_compressed.png`;

export const BRAND_ASSETS = {
  logo: `${COMMON_ASSETS}/agrollama_logo_green_background.png`,
  organizationLogo: SEARCH_LOGO,
  socialImage: SEARCH_LOGO,
  mascot: `${COMMON_ASSETS}/agrollama_mascot_green_background.png`,
};
